import { Stack } from 'expo-router';
import React from 'react';

import { BulkIncomeSplitSimulationPage } from '../../income-split-bulk/components/BulkIncomeSplitSimulationPage';

export default function IncomeSplitBulkIndexPage() {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Bulk Income Split Simulation',
                }}
            />
            <BulkIncomeSplitSimulationPage />
        </>
    );
}
